(function () {
  'use strict';

  var blockedValues = { auto: true, none: true };
  var pending = false;

  function hasGlobalSelector(selectorText) {
    return String(selectorText || '')
      .split(',')
      .some(function (selector) { return selector.trim() === '*'; });
  }

  function sanitizeRuleList(ruleList) {
    if (!ruleList) return;

    for (var index = ruleList.length - 1; index >= 0; index -= 1) {
      var rule = ruleList[index];

      if (rule.cssRules) {
        sanitizeRuleList(rule.cssRules);
        continue;
      }

      if (!rule.style || !hasGlobalSelector(rule.selectorText)) continue;

      var value = rule.style.getPropertyValue('pointer-events').trim().toLowerCase();
      var priority = rule.style.getPropertyPriority('pointer-events').toLowerCase();

      if (priority === 'important' && blockedValues[value]) {
        rule.style.removeProperty('pointer-events');
      }
    }
  }

  function sanitizeStyle(styleElement) {
    if (!styleElement || styleElement.tagName !== 'STYLE') return;

    try {
      sanitizeRuleList(styleElement.sheet && styleElement.sheet.cssRules);
    } catch (error) {
      // Ignore stylesheets that the browser does not allow this page to inspect.
    }
  }

  function sanitizeDocument() {
    document.querySelectorAll('style').forEach(sanitizeStyle);
  }

  function scheduleSanitize() {
    if (pending) return;
    pending = true;

    window.requestAnimationFrame(function () {
      pending = false;
      sanitizeDocument();
    });
  }

  function start() {
    sanitizeDocument();

    new MutationObserver(function (mutations) {
      var shouldSanitize = mutations.some(function (mutation) {
        if (mutation.type === 'characterData') {
          return mutation.target.parentElement && mutation.target.parentElement.tagName === 'STYLE';
        }
        if (mutation.target && mutation.target.nodeType === 1 && mutation.target.tagName === 'STYLE') return true;

        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          if (node.parentElement && node.parentElement.tagName === 'STYLE') return true;
          return node.nodeType === 1 && (node.tagName === 'STYLE' || node.querySelector('style'));
        });
      });

      if (shouldSanitize) scheduleSanitize();
    }).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    window.addEventListener('load', scheduleSanitize, { once: true });
    [500, 1500, 3500, 8000].forEach(function (delay) {
      window.setTimeout(scheduleSanitize, delay);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}());
